/* ============================================================================
 * tp-hero-search.js  —  Suche der Startseiten-Hero (Drucker UND Produkte)
 * ----------------------------------------------------------------------------
 * Wird von sections/tp-hero-finder.liquid geladen. Reines JavaScript ohne
 * Abhaengigkeiten, laeuft im Browser und (zum Testen) in jeder JS-Umgebung.
 *
 *   var s = TPHeroSearch.create(tree, priority);   // Druckerbaum der druckersuche-index.json
 *   s.setProducts(docs);                           // optional: products[] der search-index.json
 *   var r = s.suggest('patrone hp 30');
 *   // r = { intent: 'printer' | 'product' | 'mixed', z, confidence, reasons[],
 *   //       printers: [entry], products: [doc], lead: 'printer' | 'product', partNo }
 *
 * 1) Fehlertolerante Suche (Tippfehler, Leerzeichen, Gross/Klein) — dieselbe Engine fuer Drucker
 *    und Produkte (unveraendert aus der Hero uebernommen, nur verallgemeinert).
 * 2) Absichtserkennung: Passt die bisherige Eingabe eher zu einem Drucker oder zu einem Produkt?
 *    Das Ergebnis ist ein Wert z (>0 = Produkt, <0 = Drucker) aus drei Quellen:
 *      a) Signalwoerter  („Patrone“, „Toner“, „XL“, „schwarz“ → Produkt; „Drucker“ → Drucker;
 *         „Patrone fuer <Modell>“ → Drucker: Ziel ist die Ergebnisseite dieses Druckers)
 *      b) Daten: Wie haeufig kommt jedes Suchwort in den Druckernamen und wie in den Produkttiteln
 *         vor? (Log-Verhaeltnis: „deskjet“ nur bei Druckern, „305xl“ nur bei Produkten, „hp“ bei beiden → 0)
 *      c) Form: Sieht die Eingabe wie eine Artikelnummer aus und gibt es keinen Drucker dieses Namens?
 *    |z| < MARGIN heisst „mixed“ (beides zeigen, Drucker vorn, weil die Hero nach dem Drucker fragt).
 * ==========================================================================*/
(function (global) {
  'use strict';

  var FZ_MAX = 8;
  var MARGIN = 1.0;
  var FZ_STOP_PRINTER = {
    drucker: 1, printer: 1, multifunktionsdrucker: 1, laserdrucker: 1, tintenstrahldrucker: 1,
    tintenstrahl: 1, tinte: 1, toner: 1, patrone: 1, patronen: 1, fur: 1, fuer: 1, mein: 1, meinen: 1, meine: 1, mit: 1
  };
  var FZ_STOP_PRODUCT = { fur: 1, fuer: 1, mein: 1, meinen: 1, meine: 1, mit: 1, und: 1, der: 1, die: 1, das: 1, von: 1, zu: 1, for: 1, passend: 1, passende: 1, passender: 1 };
  /* Suchwort → gleichwertige Schreibweisen im Titel (nur exakte Treffer, kein Tippfehler-Abgleich) */
  var SYN = {
    cartridge: ['patrone'], cartridges: ['patrone'], kartusche: ['patrone'], kartuschen: ['patrone'],
    black: ['schwarz'], schwarz: ['black'], yellow: ['gelb'], gelb: ['yellow'], drum: ['trommel'], trommel: ['drum'],
    ink: ['tinte'], lasertoner: ['toner']
  };

  var fzP0 = new Int16Array(128), fzP1 = new Int16Array(128), fzP2 = new Int16Array(128);

  function spaced(s) {
    s = String(s || '').toLowerCase().replace(/ß/g, 'ss');
    if (s.normalize) s = s.normalize('NFD').replace(/[̀-ͯ]/g, '');
    return s.replace(/[^a-z0-9]+/g, ' ').trim();
  }
  function charIdx(code) {
    return code >= 97 ? code - 97 : code - 48 + 26; /* a–z → 0–25, 0–9 → 26–35 */
  }
  function clamp(x, lo, hi) { return x < lo ? lo : x > hi ? hi : x; }

  /* Erlaubte Tippfehler pro Suchwort — kurze Wörter bleiben streng, sonst gäbe es Zufallstreffer */
  function maxEdits(t) {
    var L = t.length, hasD = /\d/.test(t), hasL = /[a-z]/.test(t);
    if (L <= 3) return 0;
    if (hasD && !hasL) return 1;
    if (hasD) return L <= 4 ? 0 : L >= 9 ? 2 : 1;
    return L >= 9 ? 2 : 1;
  }

  /* Näherungs-Teilstring-Suche (Damerau/OSA): kleinste Editierdistanz von p zu irgendeinem Teilstück von t */
  function approx(p, t, k) {
    var m = p.length, n = t.length;
    if (m > 120) return k + 1;
    var prev2 = fzP2, prev = fzP1, cur = fzP0, i, j, best = m;
    for (i = 0; i <= m; i++) prev[i] = i;
    for (j = 1; j <= n; j++) {
      var tc = t.charCodeAt(j - 1), tp = j > 1 ? t.charCodeAt(j - 2) : -1;
      cur[0] = 0;
      for (i = 1; i <= m; i++) {
        var pc = p.charCodeAt(i - 1), cost = pc === tc ? 0 : 1, v = prev[i - 1] + cost, a = prev[i] + 1;
        if (a < v) v = a;
        a = cur[i - 1] + 1;
        if (a < v) v = a;
        if (i > 1 && j > 1 && cost && pc === tp && p.charCodeAt(i - 2) === tc) {
          a = prev2[i - 2] + 1;
          if (a < v) v = a;
        }
        cur[i] = v;
      }
      if (cur[m] < best) { best = cur[m]; if (best === 0) break; }
      var tmp = prev2; prev2 = prev; prev = cur; cur = tmp;
    }
    return best <= k ? best : k + 1;
  }

  /* ═══ Engine: ein Index aus Eintraegen {full: 'Text', …} ═══ */
  function createEngine(list, opt) {
    var stop = opt.stop || {}, minSub = opt.minSub || 2, bonus = opt.bonus, useSyn = !!opt.syn, vocabFuzzy = !!opt.vocabFuzzy;
    var counts = new Uint8Array(list.length * 36), vocab = Object.create(null), vocabKeys = null;
    list.forEach(function (e, n) {
      var sp = spaced(e.full);
      e.sp = ' ' + sp;
      e.c = sp.replace(/ /g, '');
      e.o = n * 36;
      for (var i = 0; i < e.c.length; i++) {
        var k = e.o + charIdx(e.c.charCodeAt(i));
        if (counts[k] < 255) counts[k]++;
      }
      var seen = {};
      sp.split(' ').forEach(function (w) {
        if (w && !seen[w]) { seen[w] = 1; vocab[w] = (vocab[w] || 0) + 1; }
      });
    });

    function parse(q) {
      var seen = {}, out = [];
      spaced(q).split(' ').forEach(function (t) {
        if (!t || stop[t] || seen[t]) return;
        seen[t] = 1;
        var cnt = {}, cc = [], i;
        for (i = 0; i < t.length; i++) {
          var ci = charIdx(t.charCodeAt(i));
          cnt[ci] = (cnt[ci] || 0) + 1;
        }
        Object.keys(cnt).forEach(function (ci) { cc.push(+ci, cnt[ci]); });
        out.push({ t: t, w: ' ' + t, k: maxEdits(t), cc: cc, alts: useSyn && SYN[t] ? SYN[t].map(function (a) { return ' ' + a; }) : null });
      });
      return out;
    }

    /* Kaum Fehlalarme: Ein Suchwort mit ≤k Fehlern teilt mindestens (Länge − k) Zeichen mit dem Text */
    function passes(e, tk) {
      var hit = 0;
      for (var i = 0; i < tk.cc.length; i += 2) {
        var c = counts[e.o + tk.cc[i]];
        hit += c < tk.cc[i + 1] ? c : tk.cc[i + 1];
      }
      return hit >= tk.t.length - tk.k;
    }

    /* Tippfehler-Suche ueber den Wortschatz (schnell bei langen Titeln): Woerter im Index, die hoechstens k Fehler vom Suchwort entfernt sind */
    var candMemo = Object.create(null);
    function candidates(tk) {
      var c = candMemo[tk.t];
      if (c) return c;
      if (!vocabKeys) vocabKeys = Object.keys(vocab);
      c = [];
      for (var i = 0; i < vocabKeys.length; i++) {
        var w = vocabKeys[i];
        if (w.length - tk.t.length > tk.k || tk.t.length - w.length > tk.k || w === tk.t) continue;
        var d = wordDist(tk.t, w, tk.k);
        if (d <= tk.k) c.push({ w: ' ' + w, d: d });
      }
      return (candMemo[tk.t] = c);
    }

    /* Kosten eines Suchworts fuer einen Eintrag; -1 = kein Treffer */
    function tokenCost(e, tk, fuzzy) {
      if (e.sp.indexOf(tk.w) >= 0) return 0; /* Wortanfang */
      if (tk.alts) {
        for (var a = 0; a < tk.alts.length; a++) if (e.sp.indexOf(tk.alts[a]) >= 0) return 0.1;
      }
      if (tk.t.length < minSub) return -1;
      if (e.c.indexOf(tk.t) >= 0) return 0.3; /* irgendwo im Namen, auch über Leerzeichen hinweg */
      if (fuzzy && tk.k > 0 && vocabFuzzy) {
        var cd = candidates(tk), best = -1;
        for (var ci = 0; ci < cd.length; ci++) {
          if (e.sp.indexOf(cd[ci].w) >= 0 && (best < 0 || cd[ci].d < best)) best = cd[ci].d;
        }
        return best < 0 ? -1 : 0.8 + 0.6 * best;
      }
      if (fuzzy && tk.k > 0 && passes(e, tk)) {
        var d = approx(tk.t, e.c, tk.k);
        if (d <= tk.k) return 0.8 + 0.6 * d;
      }
      return -1;
    }

    function scan(toks, fuzzy, max) {
      var top = [], qc = toks.map(function (x) { return x.t; }).join(''), allowMiss = fuzzy && toks.length >= 3 ? 1 : 0;
      for (var n = 0; n < list.length; n++) {
        var e = list[n], score = 0, miss = 0, start = true;
        for (var i = 0; i < toks.length; i++) {
          var c = tokenCost(e, toks[i], fuzzy);
          if (c < 0) {
            if (++miss > allowMiss) break;
            score += 3;
            start = false;
          } else {
            score += c;
            if (c > 0.1) start = false;
          }
        }
        if (miss > allowMiss) continue;
        score += bonus(e, qc, toks);
        if (top.length < max || score < top[top.length - 1].score) {
          var pos = top.length;
          while (pos > 0 && top[pos - 1].score > score) pos--;
          top.splice(pos, 0, { e: e, score: score, start: start });
          if (top.length > max) top.pop();
        }
      }
      return top;
    }

    /* → { items: [Eintrag], exact: Treffer ohne Tippfehler-Abgleich?, strict: ein Treffer, bei dem JEDES Suchwort
         am Wortanfang steht (nicht nur irgendwo im Namen), toks } */
    function search(q, max, noFuzzy) {
      max = max || FZ_MAX;
      var toks = parse(q);
      if (!toks.length) return { items: [], exact: false, strict: false, toks: toks, n: 0 };
      var res = scan(toks, false, max), exact = res.length > 0, strict = false;
      for (var i = 0; i < res.length; i++) if (res[i].start) { strict = true; break; }
      if (res.length < max && !noFuzzy) {
        var more = scan(toks, true, max);
        if (more.length > res.length) res = more;
      }
      return { items: res.map(function (r) { return r.e; }), exact: exact, strict: strict, toks: toks, n: res.length };
    }

    /* Anzahl Eintraege, in deren Woertern das Suchwort vorkommt (Wortanfang zaehlt voll, mitten im Wort 0,3) */
    var dfMemo = Object.create(null);
    function df(t) {
      if (dfMemo[t] !== undefined) return dfMemo[t];
      if (!vocabKeys) vocabKeys = Object.keys(vocab);
      var d = 0;
      for (var i = 0; i < vocabKeys.length; i++) {
        var w = vocabKeys[i], p = w.indexOf(t);
        if (p === 0) d += vocab[w];
        else if (p > 0 && t.length >= 3) d += 0.3 * vocab[w];
      }
      return (dfMemo[t] = d);
    }

    return { size: list.length, parse: parse, search: search, df: df };
  }

  /* ═══ Signalwoerter ═══ */
  /* Kategorie-Woerter: starkes Signal fuer „Produkt“ */
  var PRODUCT_CORE = [
    'patrone', 'patronen', 'tintenpatrone', 'tintenpatronen', 'druckerpatrone', 'druckerpatronen', 'kartuschen', 'tintenflaschen', 'toner', 'tonerkartusche', 'tinte', 'tintenflasche', 'trommel', 'bildtrommel',
    'drum', 'kartusche', 'cartridge', 'papier', 'fotopapier', 'farbband', 'resttoner', 'druckkopf', 'refill', 'nachfullpatrone',
    'multipack', 'sparset', 'doppelpack'
  ];
  /* Eigenschaften, die fast nur Produkte haben: schwaches Signal */
  /* Produktwoerter sind in Druckernamen nie enthalten: bei der Druckersuche zaehlen sie nicht als Suchwort */
  PRODUCT_CORE.forEach(function (w) { FZ_STOP_PRINTER[w] = 1; });
  var PRODUCT_WEAK = ['original', 'kompatibel', 'schwarz', 'black', 'cyan', 'magenta', 'gelb', 'yellow', 'xl', 'xxl', 'rebuilt'];
  var PRINTER_WORDS = ['drucker', 'printer', 'multifunktionsdrucker', 'multifunktionsgerat', 'laserdrucker', 'tintenstrahldrucker', 'farbdrucker', 'mfp', 'allinone', 'modell', 'model'];

  /* Editierdistanz (Damerau/OSA) zweier Woerter, abgebrochen ab k+1 */
  function wordDist(a, b, k) {
    var la = a.length, lb = b.length;
    if (Math.abs(la - lb) > k) return k + 1;
    var d = [], i, j;
    for (i = 0; i <= la; i++) { d[i] = [i]; }
    for (j = 1; j <= lb; j++) d[0][j] = j;
    for (i = 1; i <= la; i++) {
      for (j = 1; j <= lb; j++) {
        var cost = a.charCodeAt(i - 1) === b.charCodeAt(j - 1) ? 0 : 1, v = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + cost);
        if (i > 1 && j > 1 && cost && a.charCodeAt(i - 1) === b.charCodeAt(j - 2) && a.charCodeAt(i - 2) === b.charCodeAt(j - 1)) v = Math.min(v, d[i - 2][j - 2] + 1);
        d[i][j] = v;
      }
    }
    return d[la][lb];
  }
  function fuzzyIn(t, words) {
    if (t.length < 5) return false;
    var k = t.length >= 9 ? 2 : 1;
    for (var i = 0; i < words.length; i++) if (words[i].length >= 5 && wordDist(t, words[i], k) <= k) return true;
    return false;
  }
  function isPrefixOfAny(t, words) {
    for (var i = 0; i < words.length; i++) if (words[i].indexOf(t) === 0) return true;
    return false;
  }
  function wordKind(t, isLast) {
    /* → 'core' | 'weak' | 'printer' | '' */
    var i;
    if (t.length >= 6 && /(drucker|printer)$/.test(t)) return 'printer';
    for (i = 0; i < PRINTER_WORDS.length; i++) if (t === PRINTER_WORDS[i]) return 'printer';
    for (i = 0; i < PRODUCT_CORE.length; i++) {
      var s = PRODUCT_CORE[i];
      if (t === s || (t.length > s.length && t.indexOf(s) === 0 && t.length - s.length <= 3)) return 'core'; /* patronen, tonern */
      if (s.length >= 6 && t.length > s.length && t.indexOf(s) >= 0) return 'core'; /* lasertoner, schwarzpatrone */
    }
    for (i = 0; i < PRODUCT_WEAK.length; i++) if (t === PRODUCT_WEAK[i]) return 'weak';
    if (isLast && t.length >= 3) {
      /* noch nicht fertig getippt: „patr“, „ton“, „druckerpa“ */
      var pc = isPrefixOfAny(t, PRODUCT_CORE), pr = isPrefixOfAny(t, PRINTER_WORDS);
      if (pc && !pr) return 'core';
      if (pr && !pc) return 'printer';
      if (pc && pr) return '';
      if (t.length >= 4 && isPrefixOfAny(t, PRODUCT_WEAK)) return 'weak';
    }
    if (fuzzyIn(t, PRODUCT_CORE)) return 'core'; /* „patrnoe“, „tintenpatorne“ */
    if (fuzzyIn(t, PRINTER_WORDS)) return 'printer';
    return '';
  }

  /* Sieht die Eingabe wie eine Artikelnummer aus (305XL, TN-2420, T6N02AE)? */
  function looksLikePartNo(q) {
    var sq = String(q || '').toLowerCase().replace(/[\s\-_.\/]+/g, '');
    if (sq.length < 3 || sq.length > 16) return false;
    if (!/^[a-z0-9]+$/.test(sq)) return false;
    if (String(q).trim().split(/\s+/).length > 3) return false;
    return /^[a-z]{0,4}\d+[a-z0-9]*$/.test(sq) && (sq.match(/\d/g) || []).length >= 2;
  }

  /* Enthaelt die Eingabe eine Modellnummer (Wort mit Ziffer, mindestens 3 Zeichen)? */
  function hasModelToken(toks) {
    for (var i = 0; i < toks.length; i++) if (toks[i].t.length >= 3 && /\d/.test(toks[i].t)) return true;
    return false;
  }

  /* „Patrone für DeskJet 27“ → rechts von „für“ steht der Drucker */
  var FOR_RE = /^(.*?)\b(?:f(?:ü|u|ue)r|for|passend\s+(?:zu|für|fuer)|passt\s+(?:zu|für|fuer))\b\s*(.*)$/i;

  /* ═══ Hauptobjekt ═══ */
  function create(tree, priority) {
    var plist = [], prio = {};
    (priority || []).forEach(function (b) { prio[b] = 1; });
    Object.keys(tree || {}).forEach(function (b) {
      var series = tree[b];
      Object.keys(series).forEach(function (s) {
        series[s].forEach(function (m) {
          var name = typeof m === 'string' ? m : m && m.n ? m.n : '';
          if (!name) return;
          var img = typeof m === 'object' && m && m.i ? m.i : '';
          plist.push({ b: b, s: s, m: name, img: img, full: b + (s ? ' ' + s : '') + ' ' + name, p: prio[b] ? 1 : 0 });
        });
      });
    });
    var printers = createEngine(plist, {
      stop: FZ_STOP_PRINTER,
      minSub: 2,
      bonus: function (e, qc) {
        var s = 0;
        if (e.c === qc) s -= 4;
        else if (e.c.indexOf(qc) >= 0) s -= 0.8;
        return s + e.c.length * 0.01 - e.p * 0.15;
      }
    });
    var products = null, pdocs = null;

    function setProducts(docs) {
      pdocs = [];
      (docs || []).forEach(function (d) {
        if (!d || !d.t) return;
        d.full = d.t + ' ' + (d.nk ? d.nk.join(' ') : '') + ' ' + (d.f || '');
        pdocs.push(d);
      });
      products = createEngine(pdocs, {
        stop: FZ_STOP_PRODUCT,
        minSub: 3,
        syn: true,
        vocabFuzzy: true,
        bonus: function (e, qc) {
          var s = e.av === false ? 0.15 : 0, nk = e.nk || [];
          for (var i = 0; i < nk.length; i++) {
            if (nk[i] === qc) { s -= 4; break; }
            if (qc.length >= 3 && nk[i].indexOf(qc) === 0) s -= 1.5;
          }
          return s + e.c.length * 0.003;
        }
      });
    }

    /* Signalwoerter der Eingabe → { z, reasons } (z>0 Produkt) */
    function cueScore(rawToks) {
      var z = 0, reasons = [], core = 0, weak = 0, prn = 0;
      rawToks.forEach(function (t, i) {
        var k = wordKind(t, i === rawToks.length - 1);
        if (k === 'core') core++;
        else if (k === 'weak') weak++;
        else if (k === 'printer') prn++;
      });
      if (core) { z += 3.5 + 0.7 * Math.min(core - 1, 2); reasons.push('Produktwort'); }
      if (weak) { z += 1.5 + 0.3 * Math.min(weak - 1, 2); reasons.push('Produkteigenschaft'); }
      if (prn) { z -= 3.5; reasons.push('Druckerwort'); }
      return { z: z, reasons: reasons, core: core, weak: weak, prn: prn };
    }

    function suggest(q, opts) {
      opts = opts || {};
      var maxPrinters = opts.maxPrinters || FZ_MAX, maxProducts = opts.maxProducts || 5;
      var reasons = [], z = 0, rawToks = spaced(q).split(' ').filter(Boolean);
      var part = looksLikePartNo(q), forPrinter = false, pq = q;

      var m = FOR_RE.exec(String(q || ''));
      if (m && spaced(m[2]).length >= 2) {
        pq = m[2];
        forPrinter = true;
      }
      var cs = cueScore(forPrinter ? spaced(m[1]).split(' ').filter(Boolean) : rawToks);
      /* Teure Tippfehler-Suche nur dort, wo sie etwas aendern kann (Laufzeit auf Handys) */
      var pres = printers.search(pq, maxPrinters, !forPrinter && cs.core > 0);
      var qres = products && !forPrinter ? products.search(q, Math.max(maxProducts, 3), pres.strict && !cs.core) : { items: [], exact: false, strict: false, toks: [], n: 0 };
      /* Staerke des besten Treffers: 1 = jedes Suchwort am Wortanfang, 0,6 = irgendwo im Namen, 0,3 = nur mit Tippfehler */
      var sp = pres.strict ? 1 : pres.exact ? 0.6 : pres.items.length ? 0.3 : 0;
      var sq = qres.strict ? 1 : qres.exact ? 0.6 : qres.items.length ? 0.3 : 0;
      if (cs.core && !forPrinter) sp = 0; /* „Patrone color“: Wer „Patrone“ schreibt, will ein Produkt, auch wenn „color“ in Druckernamen steckt */

      if (forPrinter) {
        /* „Patrone für <Modell>“: gesucht ist die Ergebnisseite dieses Druckers */
        if (pres.items.length) {
          z -= 3 + sp;
          reasons.push('für-Drucker');
        } else {
          z += cs.z;
          reasons = reasons.concat(cs.reasons);
        }
      } else {
        /* a) Signalwoerter */
        z += cs.z;
        reasons = reasons.concat(cs.reasons);

        /* b) Treffer: Gibt es einen Drucker bzw. ein Produkt, das zu ALLEN Suchwoertern passt? */
        if (products) {
          z += 2 * (sq - sp);
          if (sq !== sp) reasons.push(sq > sp ? 'Produkttreffer' : 'Druckertreffer');
          var top = qres.items[0], sqz = spaced(q).replace(/ /g, '');
          if (top && top.nk && top.nk.indexOf(sqz) >= 0) { z += 1.5; reasons.push('Artikelnummer'); }
        } else if (pres.items.length) {
          z -= sp;
        }

        /* c) Verteilung der einzelnen Suchwoerter auf Druckernamen und Produkttitel (ein Wort nur bei Druckern → Drucker) */
        if (products) {
          var np = printers.size || 1, nq = products.size || 1, llr = 0;
          rawToks.forEach(function (t, i) {
            if (t.length < 3 || FZ_STOP_PRODUCT[t] || wordKind(t, i === rawToks.length - 1)) return;
            var dp = printers.df(t), dq = products.df(t);
            if (dp + dq < 1) return; /* unbekanntes Wort (Tippfehler): keine Aussage */
            llr += clamp(Math.log(((dq + 0.5) / (nq + 1)) / ((dp + 0.5) / (np + 1))), -2.5, 2.5);
          });
          if (llr) { z += clamp(llr, -3, 3) * 0.5; reasons.push('Datenlage'); }
        }

        /* „Patrone Canon PIXMA TS5150“ (ohne „für“): Produktwort + vollständiger Druckername mit Modellnummer → Ergebnisseite des Druckers */
        if (cs.core && pres.strict && !qres.strict && hasModelToken(pres.toks)) {
          z = -4;
          reasons.push('Produktwort+Drucker');
        }

        /* d) Form: Artikelnummer-artig, aber kein Druckername so geschrieben? */
        if (part) {
          z += pres.strict ? 0.3 : pres.exact ? 1.2 : products && pres.items.length && !qres.items.length ? 0.5 : 2;
          reasons.push(pres.strict ? 'Modellnummer' : 'Nummernform');
        } else if (!cs.core && !cs.weak && !cs.prn && rawToks.length && !/\d/.test(q) && pres.items.length) {
          z -= 0.8; /* nur Buchstaben, kein Produktwort: meist Serie oder Marke („laserjet“, „pixma“) */
        }
      }

      var intent = z >= MARGIN ? 'product' : z <= -MARGIN ? 'printer' : 'mixed';
      var lead = z > 0.4 ? 'product' : 'printer'; /* Gleichstand → Drucker (Frage der Hero) */
      return {
        intent: intent, lead: lead, z: z, confidence: 1 / (1 + Math.exp(-Math.abs(z) * 1.2)), reasons: reasons,
        printers: pres.items, products: qres.items, partNo: part, forPrinter: forPrinter,
        printerExact: pres.exact, productExact: qres.exact, productsReady: !!products
      };
    }

    return { suggest: suggest, setProducts: setProducts, hasProducts: function () { return !!products; }, printerCount: plist.length };
  }

  var API = { create: create, spaced: spaced, looksLikePartNo: looksLikePartNo, MARGIN: MARGIN };
  if (typeof module !== 'undefined' && module.exports) module.exports = API;
  else global.TPHeroSearch = API;
})(typeof window !== 'undefined' ? window : this);
